import { Theme } from '@mui/material';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      outline: 'none',
    },
    MuiBackdrop: {
      root: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: theme.zIndex.modal,
      },
    },
    modalContent: {
      display: 'flex',
      flexDirection: 'column',
      '& > *': {
        flexShrink: 0,
      },
      '& > :global(#scroll)': {
        flexShrink: 'unset',
        overflowY: 'auto',
      },
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      background: theme.customPalette.white,
      boxShadow: theme.shadows[5],
      padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
      borderRadius: 0,
      outline: 'none',
      overflowY: 'auto',
      [theme.breakpoints.down('sm')]: {
        maxWidth: '80%',
      },
    },
    headerWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline',
    },
    close: {
      color: theme.customPalette.red,
      cursor: 'pointer',
      height: '28px',
      width: '28px',
    },
    heading: {
      textAlign: 'center',
      display: 'block',
      width: '100%',
      color: theme.customPalette.darkBlue,
      fontWeight: 900,
    },
    closeButtonWrapper: {
      '& .MuiIconButton-root': {
        padding: 0,
        [theme.breakpoints.down('sm')]: {
          paddingBottom: '12px',
          paddingLeft: '12px',
        },
      },
    },
  })
);
